import {
  DimeCard,
  DimeCardDescription,
  DimeCardHeader,
  DimeCardTitle,
} from '@nudool/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { EventContactsDirectory } from '../../modules/events/contacts/event-contacts-directory.js';
import { EventsSectionTabs } from '../../modules/events/events-section-tabs.js';

export const Route = createFileRoute('/events/contacts')({
  component: EventContactsPage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component
function EventContactsPage() {
  return (
    <RouteGuard route="/events/contacts">
      <DimeCard borderless className="gap-0 py-0">
        <DimeCardHeader className="mb-4 px-0">
          <DimeCardTitle className="flex items-center gap-2 text-base">Events</DimeCardTitle>
          <DimeCardDescription className="text-sm">
            Everyone you've met at events, newest first.
          </DimeCardDescription>
        </DimeCardHeader>
        <div className="flex flex-col gap-4">
          <EventsSectionTabs active="contacts" />
          <EventContactsDirectory />
        </div>
      </DimeCard>
    </RouteGuard>
  );
}
